export const fetchLeetCodeStats = async (username) => {
  if (!username) return null;
  
  try {
    const res = await fetch(`https://leetcode-api-faisalshohag.vercel.app/${username}`);
    if (!res.ok) throw new Error("LeetCode user not found");
    const data = await res.json();
    
    // API returns empty/invalid payload if user doesn't exist sometimes
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0].message);
    }

    return {
      username: username,
      totalSolved: data.totalSolved,
      easySolved: data.easySolved,
      mediumSolved: data.mediumSolved,
      hardSolved: data.hardSolved,
      ranking: data.ranking,
      url: `https://leetcode.com/${username}`
    };
  } catch (err) {
    console.error("LeetCode API Error:", err);
    throw err;
  }
};
